import React from 'react';

const ResetIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M8.5 4v5.5h-2V7.7A7 7 0 0012 19v2A9 9 0 015.3 6H3V4h5.5zM12 3a9 9 0 017.1 14.5h2.4v2H16V14h2v1.6A7 7 0 0012 5z" />
  </svg>
);

export default ResetIcon;
